import { api } from './api';

export interface LoginRequest {
  phoneNumber: string;
  password: string;
}

export interface User {
  id: number;
  username?: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  defaultWarehouseId?: number;
  /** Silme izni; false ise tüm sayfalarda Sil butonu gizlenir. */
  canDelete?: boolean;
  canCancelServiceOrder?: boolean;
  roles: string[];
  roleCodes?: string[];
  permissions: string[];
}

export interface LoginResponse {
  token: string;
  refreshToken: string;
  expiresAt: string;
  user: User;
}

export const authService = {
  async login(phoneNumber: string, password: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', { phoneNumber, password });
    return response.data;
  },

  async refreshToken(refreshToken: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/refresh', { refreshToken });
    return response.data;
  },

  async logout(token: string): Promise<void> {
    await api.post('/auth/logout', {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  async validateToken(token: string): Promise<boolean> {
    try {
      await api.post('/auth/validate', { token });
      return true;
    } catch {
      return false;
    }
  },

  async forgotPassword(email: string): Promise<void> {
    await api.post('/auth/forgot-password', { email });
  },

  async resetPassword(token: string, newPassword: string): Promise<void> {
    await api.post('/auth/reset-password', { token, newPassword });
  }
};
